import CrossSVG from '@public/icons/cross.svg';
import StarSVG from '@public/icons/star.svg';
import classNames from 'classnames';
import { m as motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useSetFavoriteWindowState } from '@/shared/atoms/favorite-window';

interface Props {
    isScrollButtonVisible: boolean;
}

function FavoriteBtn({ isScrollButtonVisible }: Props) {
    const [isOpen, setIsOpen] = useState(false);
    const setFavoriteWindow = useSetFavoriteWindowState();

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        isOpen ? setFavoriteWindow(true) : setFavoriteWindow(false);
    }, [isOpen]);

    return (
        <motion.div
            exit={{ opacity: 0 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className={classNames('favorite-btn-mobile', { 'is-translated': isScrollButtonVisible })}
        >
            <motion.button
                className={classNames('favorite-btn', { 'is-active': isOpen })}
                onClick={toggleOpen}
                aria-label="Открыть форму обратной связи"
            >
                <motion.div
                    initial={{ opacity: 0, y: 5 }}
                    animate={{ opacity: isOpen ? 1 : 0, y: isOpen ? 0 : 5 }}
                    transition={{ duration: 0.3 }}
                    key="cross-svg"
                    className="favorite-btn-svg-wrapper"
                >
                    {isOpen && <CrossSVG />}
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: !isOpen ? 1 : 0, y: !isOpen ? 0 : 20 }}
                    transition={{ duration: 0.3 }}
                    key="favorite-svg"
                >
                    {!isOpen && <StarSVG className="star-btn-svg" />}
                </motion.div>
            </motion.button>
        </motion.div>
    );
}

export default FavoriteBtn;
